import { Title } from "react-admin";
import { useSearchParams } from "react-router-dom";
import { RazaEventsCalendarView } from "./RazaEventsCalendarView";
import RazaEventsListView from "./RazaEventsListView";

export default function RazaEventsList() {
  const [searchParams] = useSearchParams();
  const viewParam = searchParams.get("tab") || "CALENDAR";
  return (
    <div>
      <Title title="Raza events" />
      {viewParam === "CALENDAR" && <RazaEventsCalendarView />}
      {viewParam === "LIST" && <RazaEventsListView />}
    </div>
  );
}
